import AppIcons from "../../components/Base/AppIcons/AppIcons";
import HNavbar from "../../components/Base/HNavbar/HNavbar";
import { TypingRoutes } from "../../utils/TypingUtils";
import rutasTripleA from "../OtrasEntidades/TripleA/rutasTripleA"
import rutasCrezcamos from "./Crezcamos/routes";
import rutasVeolia from "../OtrasEntidades/Veolia/rutasVeolia"
const routesOtrasEntidades = {
  link: "/OtrasEntidades",
  label: <AppIcons Logo={"RECARGA_CELULAR"} name="Otras Entidades" />,
  component: ({ subRoutes }: { subRoutes: TypingRoutes[] }) => (
    <HNavbar links={subRoutes} />
  ),
  permission: [158, 27030, 31000],
  subRoutes: [
    rutasTripleA,
    rutasCrezcamos,
    rutasVeolia
  ],
};

export default routesOtrasEntidades;
